import type { Locale } from '../lib/api/types'

/**
 * The single source of truth for which languages the app ships.
 *
 * Deliberately free of i18next and the locale JSON so the build (vite.config) can read it to emit
 * the sitemap without booting the whole i18n stack — the sitemap and the app can never disagree
 * about which languages exist.
 */
export const SUPPORTED_LOCALES: Locale[] = ['it', 'en', 'de', 'fr', 'hr', 'sl', 'zh']

/** Fallback whenever a locale is absent or unrecognised. */
export const DEFAULT_LOCALE: Locale = 'it'
